import apiConfig from "../config";
import { AuthRequest, RoleType, TokenType } from "../../Types/Auth";

interface ServerResponse {
	data: RequestSuccessType;
}

interface RequestSuccessType {
	token: TokenType;
	owner: {
		id?: number;
		status?: number;
		firstname?: string;
		surname?: string;
		email?: string;
		roles?: RoleType[];
	};
	loginType?: number;
}

interface RequestResponse extends RequestSuccessType {
	isErr: string | undefined;
	status?: number;
	validationError: { name: string; message: string } | undefined;
}

const login = ({
	// возможно битый брошенный компонент...позже понять
	email,
	password,
	rememberMe,
	debounce,
}: AuthRequest): Promise<RequestResponse> => {
	return apiConfig()
		.post<ServerResponse>(`/user/auth`, {
			email: email,
			password: password,
			rememberMe,
			debounce,
		})
		.then(({ data }: { data: any }) => {
			const response: RequestResponse = {
				isErr: undefined,
				validationError: undefined,
				token: data.data.token,
				owner: {
					id: data.data.owner.id,
					status: data.data.owner.status,
					firstname: data.data.owner.firstname,
					surname: data.data.owner.surname,
					email: data.data.owner.email,
					roles: data.data.owner.roles,
				},
				loginType: data.data.loginType,
			};
			return response;
		})
		.catch((data: any) => {
			const response: RequestResponse = {
				isErr: data.response.data.message,
				validationError: data.response.data.validationError.body[0],
				token: undefined,
				status: data.response.status,
				owner: {
					id: undefined,
					status: undefined,
					firstname: undefined,
					surname: undefined,
					email: undefined,
					roles: [],
				},
				loginType: undefined,
			};
			return response;
		});
};

export default login;
